const menu = [
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
    allowedRights: ["ADMIN"],
  },
  {
    icon: "users",
    text: "User Management",
    active: false,
    allowedRights: ["VIEW_ADMIN_USER", "VIEW_ROLE", "VIEW_BRANCH", "VIEW_DEPARTMENT"],
    subMenu: [
      {
        text: "Manage Users",
        link: "/manage-users",
        allowedRights: ["VIEW_ADMIN_USER"],
      },
      {
        text: "Manage Roles",
        link: "/manage-roles",
        allowedRights: ["VIEW_ROLE"],
      },
      {
        text: "Branch Management",
        link: "/manage-branch",
        allowedRights: ["VIEW_BRANCH"],
      },
      {
        text: "Department Management",
        link: "/department-management",
        allowedRights: ["VIEW_DEPARTMENT"],
      },
    ],
  },
  {
    icon: "card-view",
    text: "Product Management",
    active: false,
    allowedRights: [
      "VIEW_PRODUCT_CATEGORY",
      "VIEW_PRODUCT",
      "VIEW_TENOR",
      "VIEW_WITHDRAWAL_REASON",
      "VIEW_CURRENCY",
      "VIEW_INVESTMENT_RATE",
      "VIEW_WITHHOLDING_TAX_RATE",
      "VIEW_PENAL_CHARGE",
      "VIEW_EXCHANGE_RATE",
      "VIEW_WALLET_MANAGEMENT",
      "VIEW_PRODUCT_PROPERTY",
    ],
    subMenu: [
      {
        text: "Product Category",
        link: "/product-category",
        allowedRights: ["VIEW_PRODUCT_CATEGORY"],
      },
      {
        text: "Products",
        link: "/products",
        allowedRights: ["VIEW_PRODUCT"],
      },
      // {
      //   text: "Product Property",
      //   link: "/product-property",
      //   allowedRights: ["VIEW_PRODUCT_PROPERTY"],
      // },
      {
        text: "Tenor Management",
        link: "/tenor-management",
        allowedRights: ["VIEW_TENOR"],
      },
      {
        text: "Withdrawal Reasons",
        link: "/withdrawal-reason",
        allowedRights: ["VIEW_WITHDRAWAL_REASON"],
      },
      {
        text: "Investment Rates",
        link: "/investment-rate",
        allowedRights: ["VIEW_INVESTMENT_RATE"],
      },
      {
        text: "Withholding Tax rates",
        link: "/withholding-tax",
        allowedRights: ["VIEW_WITHHOLDING_TAX_RATE"],
      },
      {
        text: "Penal charge",
        link: "/penal-charge",
        allowedRights: ["VIEW_PENAL_CHARGE"],
      },
      {
        text: "Currency Management",
        link: "/currency-management",
        allowedRights: ["VIEW_CURRENCY"],
      },
      {
        text: "Exchange Rates",
        link: "/exchange-rate",
        allowedRights: ["VIEW_EXCHANGE_RATE"],
      },
      {
        text: "Wallet Management",
        link: "/wallet-management",
        allowedRights: ["VIEW_WALLET_MANAGEMENT"],
      },
    ],
  },
  {
    icon: "tranx",
    text: "Process Management",
    active: false,
    allowedRights: ["VIEW_PROCESS_FLOW"],
    subMenu: [
      {
        text: "Process",
        link: "/process-management",
        allowedRights: ["VIEW_PROCESS_FLOW"],
      },
      {
        text: "Process Stage",
        link: "/manage-process-stage",
        allowedRights: ["VIEW_PROCESS_FLOW"],
      },
    ],
  },

  {
    icon: "user",
    text: "Customer management",
    active: false,
    allowedRights: [
      "VIEW_CUSTOMER",
      "VIEW_GENDER",
      "VIEW_IDENTIFICATION_TYPE",
      "VIEW_SOURCE",
      "WITHDRAW_INVESTMENT",
      "TOPUP_INVESTMENT",
      "CREATE_INVESTMENT",
      "TRANSFER_INVESTMENT",
    ],
    subMenu: [
      {
        text: "Customer Databoard",
        link: "/customer-databoard",
        allowedRights: ["VIEW_CUSTOMER", "CREATE_INVESTMENT"],
      },
      {
        text: "Customer investments",
        link: "/customer-investments",
        allowedRights: ["WITHDRAW_INVESTMENT", "TOPUP_INVESTMENT", "TRANSFER_INVESTMENT"],
      },
      {
        text: "Gender management",
        link: "/manage-gender",
        allowedRights: ["VIEW_GENDER"],
      },
      {
        text: "Identification type Setup",
        link: "/identifation-type",
        allowedRights: ["VIEW_IDENTIFICATION_TYPE"],
      },
      {
        text: "Source Management",
        link: "/source-management",
        allowedRights: ["VIEW_SOURCE"],
      },
    ],
  },

  {
    icon: "user",
    text: "My Customer",
    active: false,
    allowedRights: ["ADMIN"],
    subMenu: [
      {
        text: "My Customers Management",
        link: "/manage-my-customers",
        allowedRights: ["ADMIN"],
      },
    ],
  },
  {
    icon: "growth",
    text: "Referral Rewards",
    active: false,
    allowedRights: ["ADMIN"],
    link: "/referral-rewards",
  },
  // { heading: "FeedBacks", allowedRights: [""] },
  {
    icon: "file-docs",
    text: "Request Centre",
    active: false,
    allowedRights: ["TREAT_REQUEST"],
    subMenu: [
      {
        text: "Pending Requests",
        link: "/pending-requests",
        allowedRights: ["TREAT_REQUEST"],
      },
      {
        text: "My Queue",
        link: "/my-queue",
        allowedRights: ["TREAT_REQUEST"],
      },
      {
        text: "Handled Requests",
        link: "/handled-requests",
        allowedRights: ["TREAT_REQUEST"],
      },
      {
        text: "Delete Requests",
        link: "/delete-requests",
        allowedRights: ["TREAT_REQUEST"],
      }
    ],
  },
  {
    icon: "chat",
    text: "Message Centre",
    active: false,
    allowedRights: ["VIEW_MESSAGE"],
    subMenu: [
      {
        text: "Manage Messages",
        link: "/manage-messages",
        allowedRights: ["VIEW_MESSAGE"],
      },
    ],
  },
  {
    icon: "ticket",
    text: "FeedBack Centre",
    active: false,
    allowedRights: ["VIEW_TICKET_CATEGORY", "VIEW_TICKET"],
    subMenu: [
      {
        text: "Open Tickets",
        link: "/open-tickets",
        allowedRights: ["VIEW_TICKET"],
      },
      {
        text: "Archived Tickets",
        link: "/archived-tickets",
        allowedRights: ["VIEW_TICKET"],
      },
      {
        text: "Ticket Categories",
        link: "/manage-ticket-category",
        allowedRights: ["VIEW_TICKET_CATEGORY"],
      },
    ],
  },
  {
    icon: "question",
    text: "Help Centre",
    active: false,
    allowedRights: ["VIEW_FAQ", "VIEW_FAQ_CATEGORY"],
    subMenu: [
      {
        text: "FAQ Categories",
        link: "/manage-faq-category",
        allowedRights: ["VIEW_FAQ_CATEGORY"],
      },
      {
        text: "Manage FAQ",
        link: "/manage-faq",
        allowedRights: ["VIEW_FAQ"],
      },
    ],
  },
  {
    icon:"mic",
    text:"Campaign Management",
    active:false,
    allowedRights: ["VIEW_REPORT"],
    link:"campaign-management"
  },
  {
    icon: "growth",
    text: "Report Centre",
    active: false,
    allowedRights: ["VIEW_REPORT"],
    subMenu: [
      {
        text: "Report",
        link: "/report",
        allowedRights: ["VIEW_REPORT"],
      },
    ],
  },
];
export default menu;
